import { Link } from 'react-router-dom'
import {
    RecentConsultation,
    CONSULTATION_STATUS_LABELS,
    CONSULTATION_STATUS_COLORS,
} from '@/lib/api/dashboard/dashboard-api'
import { MdLocalHospital, MdArrowForward, MdMic } from 'react-icons/md'
import { format, parseISO } from 'date-fns'

interface RecentConsultationsTableProps {
    consultations: RecentConsultation[]
}

export default function RecentConsultationsTable({
    consultations,
}: RecentConsultationsTableProps) {
    return (
        <div className="bg-base-100 rounded-xl border border-base-300/50 overflow-hidden">
            <div className="bg-gradient-to-r from-info/10 to-secondary/10 px-5 py-4 border-b border-base-300/50">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="p-2 rounded-lg bg-info/20">
                            <MdLocalHospital className="text-info text-lg" />
                        </div>
                        <h3 className="text-lg font-semibold text-base-content">
                            Consultas Recentes
                        </h3>
                    </div>
                    <Link
                        to="/bookings/consultations"
                        className="btn btn-ghost btn-sm gap-1"
                    >
                        Ver todas
                        <MdArrowForward />
                    </Link>
                </div>
            </div>

            <div className="overflow-x-auto">
                {consultations.length === 0 ? (
                    <div className="text-center py-8 text-base-content/50">
                        Nenhuma consulta recente
                    </div>
                ) : (
                    <table className="table table-sm">
                        <thead>
                            <tr className="text-xs text-base-content/60">
                                <th>Paciente</th>
                                <th>Status</th>
                                <th>Data</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {consultations.slice(0, 5).map(consultation => (
                                <tr key={consultation.id} className="hover">
                                    <td>
                                        <Link
                                            to={`/bookings/consultations/${consultation.id}`}
                                            className="font-medium text-base-content hover:text-secondary"
                                        >
                                            {consultation.clientName}
                                        </Link>
                                    </td>
                                    <td>
                                        <span
                                            className="badge badge-sm"
                                            style={{
                                                backgroundColor: `${CONSULTATION_STATUS_COLORS[consultation.status]}20`,
                                                color: CONSULTATION_STATUS_COLORS[
                                                    consultation.status
                                                ],
                                            }}
                                        >
                                            {CONSULTATION_STATUS_LABELS[
                                                consultation.status
                                            ] || consultation.status}
                                        </span>
                                    </td>
                                    <td className="text-base-content/60 text-xs">
                                        {format(
                                            parseISO(consultation.scheduledAt),
                                            'dd/MM HH:mm'
                                        )}
                                    </td>
                                    <td>
                                        {consultation.hasTranscription && (
                                            <span
                                                className="tooltip tooltip-left"
                                                data-tip="Possui transcrição"
                                            >
                                                <MdMic className="text-success" />
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    )
}
